import gql from 'graphql-tag';

const GET_AI_SIMILAR_TICKETS = gql`
  query getAISimilarTickets($ticketId: ID!) {
    getAISimilarTickets(ticketId: $ticketId) {
      ticketId
      displayId
      subject
      siteName
      resolved
    }
  }
`;

const GET_AI_UNRESOLVED_SUMMARY = gql`
  query getAIUnresolvedSummary($ticketId: ID!, $unresolvedTicketIds: [ID!]!) {
    getAIUnresolvedSummary(
      ticketId: $ticketId
      unresolvedTicketIds: $unresolvedTicketIds
    )
  }
`;

const GET_AI_RESOLVED_SUMMARY = gql`
  query getAIResolvedSummary($ticketId: ID!, $resolvedTicketIds: [ID!]!) {
    getAIResolvedSummary(
      ticketId: $ticketId
      resolvedTicketIds: $resolvedTicketIds
    ) {
      summary
      groupSummaries {
        name
        summary
      }
    }
  }
`;

export {
  GET_AI_SIMILAR_TICKETS,
  GET_AI_UNRESOLVED_SUMMARY,
  GET_AI_RESOLVED_SUMMARY
};
